/**
 * X2 이모가 붙잡기 (핸드오프 15 X2, 결정 66). 차를 고른 뒤 카운터에서 나가려 하면 한 번만.
 *
 *   손잡이 → [이모 초상 40 + 붙잡기 대사(고운바탕 18/30)] → 안내(13/20) → [더 있을게요](주요) · [다음에 올게요](보조), 52 · 반경 16
 *
 * - 바깥 탭 · 끌어내리기 · Esc · 안드로이드 뒤로 = 더 있을게요(시트만 닫힘)
 * - 대화에는 아무것도 남기지 않습니다(말풍선 · 기록 없음, 이벤트만)
 * - 열리면 [더 있을게요]에 포커스
 * - 대사는 서버가 콘텐츠(counter_lines)에서 골라 보냄(line). 없으면 앱 기본값(DEV-21)
 */
import { useEffect, useRef } from 'react';
import { LINES, POLITE_LINES } from '@config/onboarding/counterScript.js';
import { BottomSheet } from '../../components/BottomSheet.jsx';
import { Avatar } from '../../components/Avatar.jsx';

export const EXIT_LABEL = '가게 나가기';

export function ExitSheet({ open, speech = 'casual', line = null, onStay, onLeave }) {
    const stayRef = useRef(null);
    const L = speech === 'polite' ? POLITE_LINES : LINES;

    useEffect(() => {
        if (!open) {
            return undefined;
        }
        const frame = requestAnimationFrame(() => stayRef.current?.focus());
        return () => {
            cancelAnimationFrame(frame);
        };
    }, [open]);

    return (
        <BottomSheet open={open} onClose={onStay} label={EXIT_LABEL}>
            <div className="flex items-start gap-3 pt-1">
                <Avatar memberKey="imo" size={40} />
                <p className="m-0 font-serif text-[18px] leading-[30px]">{line ?? L.exitHold}</p>
            </div>
            <p className="m-0 text-[13px] leading-5 text-text-secondary">
                나가도 여기까지 나눈 얘기는 이모가 기억해요. 다음에 오면 이어서 해요.
            </p>
            <div className="flex flex-col gap-2">
                <button
                    ref={stayRef}
                    type="button"
                    onClick={onStay}
                    className="h-[52px] rounded-[16px] bg-brand text-[16px] font-semibold text-on-brand"
                >
                    더 있을게요
                </button>
                <button
                    type="button"
                    onClick={onLeave}
                    className="h-[52px] rounded-[16px] border border-brand text-[16px] font-semibold text-brand"
                >
                    다음에 올게요
                </button>
            </div>
        </BottomSheet>
    );
}
